(function () {
  function toFeet(value, unit) {
    if (unit === 'ft') return value;
    if (unit === 'in') return value / 12;
    if (unit === 'cm') return value / 30.48;
    if (unit === 'm') return value * 3.28084;
    return value;
  }

  function formatNumber(value) {
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 2
    }).format(value);
  }

  function formatCurrency(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }

  function initTileCalculator(scope) {
    const root =
      scope && scope.classList && scope.classList.contains('badia-tile-calc')
        ? scope
        : scope
        ? scope.querySelector('.badia-tile-calc')
        : document.querySelector('.badia-tile-calc');

    if (!root || root.dataset.calculatorInitialized === 'true') return;
    root.dataset.calculatorInitialized = 'true';

    const form = root.querySelector('#tileCalculatorForm');
    const results = root.querySelector('#tileCalculatorResults');
    const errorsWrap = root.querySelector('#btcErrors');
    const errorsList = errorsWrap ? errorsWrap.querySelector('ul') : null;

    const resultArea = root.querySelector('#resultArea');
    const resultRawTiles = root.querySelector('#resultRawTiles');
    const resultFinalTiles = root.querySelector('#resultFinalTiles');
    const resultBoxes = root.querySelector('#resultBoxes');
    const resultCost = root.querySelector('#resultCost');

    const copyBtn = root.querySelector('#btcCopySummary');
    const copiedMsg = root.querySelector('#btcCopiedMessage');
    const presetButtons = root.querySelectorAll('.btc-preset');

    if (!form || !results) return;

    let selectedWaste = 10;
    let lastSummary = '';

    presetButtons.forEach((button) => {
      button.addEventListener('click', function () {
        presetButtons.forEach((btn) => btn.classList.remove('is-active'));
        this.classList.add('is-active');
        selectedWaste = parseFloat(this.dataset.waste || '10');
      });
    });

    function clearErrors() {
      if (errorsWrap) errorsWrap.style.display = 'none';
      if (errorsList) errorsList.innerHTML = '';
      root.querySelectorAll('.btc-invalid').forEach((el) => el.classList.remove('btc-invalid'));
    }

    function showErrors(messages, fields) {
      if (!errorsWrap || !errorsList) return;
      errorsList.innerHTML = messages.map((msg) => `<li>${msg}</li>`).join('');
      errorsWrap.style.display = 'block';
      fields.forEach((field) => field && field.classList.add('btc-invalid'));
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearErrors();

      const unit = form.querySelector('#unit').value;
      const areaLengthField = form.querySelector('#areaLength');
      const areaWidthField = form.querySelector('#areaWidth');
      const tileLengthField = form.querySelector('#tileLength');
      const tileWidthField = form.querySelector('#tileWidth');
      const groutWidthField = form.querySelector('#groutWidth');
      const tilesPerBoxField = form.querySelector('#tilesPerBox');
      const pricePerBoxField = form.querySelector('#pricePerBox');

      const areaLength = parseFloat(areaLengthField.value);
      const areaWidth = parseFloat(areaWidthField.value);
      const tileLength = parseFloat(tileLengthField.value);
      const tileWidth = parseFloat(tileWidthField.value);
      const groutWidth = parseFloat(groutWidthField.value) || 0;
      const tilesPerBox = parseFloat(tilesPerBoxField.value) || 0;
      const pricePerBox = parseFloat(pricePerBoxField.value) || 0;

      const messages = [];
      const badFields = [];

      if (!(areaLength > 0)) {
        messages.push('Please enter a valid area length.');
        badFields.push(areaLengthField);
      }

      if (!(areaWidth > 0)) {
        messages.push('Please enter a valid area width.');
        badFields.push(areaWidthField);
      }

      if (!(tileLength > 0)) {
        messages.push('Please enter a valid tile length in inches.');
        badFields.push(tileLengthField);
      }

      if (!(tileWidth > 0)) {
        messages.push('Please enter a valid tile width in inches.');
        badFields.push(tileWidthField);
      }

      if (messages.length) {
        showErrors(messages, badFields);
        results.style.display = 'none';
        return;
      }

      const areaLengthFt = toFeet(areaLength, unit);
      const areaWidthFt = toFeet(areaWidth, unit);

      /* Tile size and grout are always entered in inches */
      const tileLengthFt = (tileLength + groutWidth) / 12;
      const tileWidthFt = (tileWidth + groutWidth) / 12;

      const totalAreaSqFt = areaLengthFt * areaWidthFt;
      const tileCoverageSqFt = tileLengthFt * tileWidthFt;
      const rawTiles = totalAreaSqFt / tileCoverageSqFt;
      const finalTiles = Math.ceil(rawTiles * (1 + selectedWaste / 100));
      const boxesNeeded = tilesPerBox > 0 ? Math.ceil(finalTiles / tilesPerBox) : null;
      const totalAreaSqM = totalAreaSqFt * 0.092903;
      const totalCost = boxesNeeded && pricePerBox > 0 ? boxesNeeded * pricePerBox : null;

      resultArea.textContent = `${formatNumber(totalAreaSqFt)} sq ft / ${formatNumber(totalAreaSqM)} sq m`;
      resultRawTiles.textContent = `${Math.ceil(rawTiles)} tiles`;
      resultFinalTiles.textContent = `${finalTiles} tiles`;
      resultBoxes.textContent = boxesNeeded ? `${boxesNeeded} boxes` : '—';
      resultCost.textContent = totalCost ? formatCurrency(totalCost) : '—';

      lastSummary =
        `Tile estimate:\n` +
        `Total area: ${formatNumber(totalAreaSqFt)} sq ft / ${formatNumber(totalAreaSqM)} sq m\n` +
        `Raw tile count: ${Math.ceil(rawTiles)} tiles\n` +
        `Final tile count: ${finalTiles} tiles\n` +
        `Boxes needed: ${boxesNeeded ? boxesNeeded + ' boxes' : '—'}\n` +
        `Estimated material cost: ${totalCost ? formatCurrency(totalCost) : '—'}`;

      results.style.display = 'block';
    });

    form.addEventListener('reset', function () {
      clearErrors();
      results.style.display = 'none';
      presetButtons.forEach((btn) => btn.classList.remove('is-active'));
      if (presetButtons[0]) presetButtons[0].classList.add('is-active');
      selectedWaste = 10;
      if (copiedMsg) copiedMsg.style.display = 'none';
      lastSummary = '';
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (!lastSummary) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(lastSummary).then(function () {
            if (copiedMsg) {
              copiedMsg.style.display = 'inline';
              setTimeout(function () {
                copiedMsg.style.display = 'none';
              }, 2000);
            }
          });
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.badia-tile-calc').forEach((root) => initTileCalculator(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTileCalculator(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll();
  });
})();